import { render, staticRenderFns } from "./transaction-status.vue?vue&type=template&id=389a6ac1&scoped=true&lang=pug"
import script from "./transaction-status.js?vue&type=script&lang=js&external"
export * from "./transaction-status.js?vue&type=script&lang=js&external"
import style0 from "./transaction-status.vue?vue&type=style&index=0&id=389a6ac1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389a6ac1",
  null
  
)

export default component.exports